import { Link } from 'react-router-dom';

export default function ContactSection() {
  return (
    <section id="contact" className="bg-black">
      {/* Main contact content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left: info */}
          <div className="flex flex-col gap-8">
            <div>
              <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="inline-block mb-6 cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/aed34eea4e280644dc241a74366b8cb3/65189eab8d9d4e700ee7712d44e24f60.png"
                  alt="OA Logo"
                  className="h-14 w-auto object-contain brightness-0 invert"
                />
              </Link>
              <blockquote className="font-serif text-sm text-white/70 leading-relaxed italic">
                <i className="ri-double-quotes-l text-[#b89a6a] not-italic mr-1" />
                Archiving is not just the act of keeping, it is the responsibility of remembering with intention. In preservation, we do more than store history; we protect the voices, textures, and truths that would otherwise fade, ensuring that identity is not lost but continuously rediscovered.
                <i className="ri-double-quotes-r text-[#b89a6a] not-italic ml-1" />
                <span className="font-sans text-xs text-[#b89a6a] tracking-widest uppercase not-italic ml-2">— OA</span>
              </blockquote>
            </div>

            <div>
              <h3 className="text-xs uppercase tracking-widest text-white/40 mb-4">CONTACT</h3>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#b89a6a] text-lg" />
                </div>
                <a
                  href="mailto:damola@oludamolaadebowale.com"
                  className="font-sans text-sm text-white hover:text-[#b89a6a] transition-colors"
                >
                  damola@oludamolaadebowale.com
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-xs uppercase tracking-widest text-white/40 mb-4">CONNECT</h3>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.linkedin.com/in/oludamola-adebowale-frhists-2a10b52a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:border-[#b89a6a] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-line text-lg text-white hover:text-[#b89a6a] transition-colors" />
                </a>
                <a
                  href="https://oauife.academia.edu/OludamolaAdebowale"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:border-[#b89a6a] transition-colors cursor-pointer"
                >
                  <i className="ri-graduation-cap-line text-lg text-white hover:text-[#b89a6a] transition-colors" />
                </a>
              </div>
            </div>
          </div>

          {/* Right: photo */}
          <div className="relative">
            <img
              src="https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/75053b87-30b1-4f47-adf6-60786070b88c_ContactMeImg.jpg?v=36ab3ec817189b0c8450ddebd5374d4c"
              alt="Oludamola Adebowale"
              className="w-full max-w-sm mx-auto lg:mx-0 rounded-lg object-cover object-center"
            />
          </div>
        </div>
      </div>

      {/* Footer bar */}
      <div className="border-t border-white/10 py-8 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-xs text-gray-500">
            © 2026 Oludamola Adebowale. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-sans text-xs text-gray-500 hover:text-white transition-colors">Privacy Policy</a>
            <span className="text-gray-700">·</span>
            <a href="#" className="font-sans text-xs text-gray-500 hover:text-white transition-colors">Terms</a>
            <span className="text-gray-700">·</span>
            <a href="#" className="font-sans text-xs text-gray-500 hover:text-white transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </section>
  );
}
